import React from 'react';
import './Rules.css';

function Rules() {
  const tierCategories = {
    1: ['Best Picture', 'Best Director', 'Best Actor', 'Best Actress'],
    2: ['Best Supporting Actor', 'Best Supporting Actress', 'Best Original Screenplay', 'Best Adapted Screenplay', 'Best Animated Feature', 'Best International Feature', 'Best Documentary Feature', 'Best Original Score'],
    3: ['Best Original Song', 'Best Cinematography', 'Best Film Editing', 'Best Production Design', 'Best Costume Design', 'Best Makeup and Hairstyling', 'Best Sound', 'Best Visual Effects', 'Best Documentary Short', 'Best Animated Short']
  };

  return (
    <div className="rules-page">
      <div className="page-header">
        <h1>Rules & Scoring</h1>
        <p>How to play and win</p>
      </div>

      <section className="rules-section card">
        <h2>How to Play</h2>
        <ol className="rules-list">
          <li>Create an account or sign in</li>
          <li>Join a group with friends or create your own</li>
          <li>Make your predictions for all 22 Oscar categories</li>
          <li>Submit your picks before the deadline</li>
          <li>Watch the Oscars and see how you did!</li>
        </ol>
      </section>

      <section className="rules-section card">
        <h2>Scoring System</h2>
        <p className="scoring-intro">Categories are divided into three tiers based on difficulty. Harder-to-predict categories are worth more points.</p>

        <div className="scoring-table-wrapper">
          <table className="scoring-table">
            <thead>
              <tr>
                <th>Tier</th>
                <th>Points</th>
                <th>Categories</th>
              </tr>
            </thead>
            <tbody>
              <tr className="tier-1-row">
                <td>
                  <span className="tier-badge gold">Tier 1</span>
                </td>
                <td className="points-cell">1 point</td>
                <td>
                  <div className="categories-list">
                    {tierCategories[1].map(cat => (
                      <span key={cat} className="category-tag">{cat}</span>
                    ))}
                  </div>
                </td>
              </tr>
              <tr className="tier-2-row">
                <td>
                  <span className="tier-badge silver">Tier 2</span>
                </td>
                <td className="points-cell">2 points</td>
                <td>
                  <div className="categories-list">
                    {tierCategories[2].map(cat => (
                      <span key={cat} className="category-tag">{cat}</span>
                    ))}
                  </div>
                </td>
              </tr>
              <tr className="tier-3-row">
                <td>
                  <span className="tier-badge bronze">Tier 3</span>
                </td>
                <td className="points-cell">3 points</td>
                <td>
                  <div className="categories-list">
                    {tierCategories[3].map(cat => (
                      <span key={cat} className="category-tag">{cat}</span>
                    ))}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="rules-section card">
        <h2>Maximum Points</h2>
        <div className="max-points">
          <div className="points-breakdown">
            <div className="breakdown-item">
              <span className="breakdown-label">Tier 1 (4 categories x 1 pt)</span>
              <span className="breakdown-value">4 pts</span>
            </div>
            <div className="breakdown-item">
              <span className="breakdown-label">Tier 2 (8 categories x 2 pts)</span>
              <span className="breakdown-value">16 pts</span>
            </div>
            <div className="breakdown-item">
              <span className="breakdown-label">Tier 3 (10 categories x 3 pts)</span>
              <span className="breakdown-value">30 pts</span>
            </div>
            <div className="breakdown-total">
              <span className="breakdown-label">Total Possible</span>
              <span className="breakdown-value">50 pts</span>
            </div>
          </div>
        </div>
      </section>

      <section className="rules-section card">
        <h2>Important Dates</h2>
        <div className="dates-list">
          <div className="date-item">
            <span className="date-label">Predictions Deadline</span>
            <span className="date-value">March 1st, 2026 at 12:00 AM</span>
          </div>
          <div className="date-item">
            <span className="date-label">Winners Announced</span>
            <span className="date-value">After March 15th, 2026</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Rules;
